import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";

import { InstallationItem } from "@/app/domain/entities/installation";
import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";

export class InstallationOldSubtotalCalculationStrategy extends CalculationStrategy {
    calculate(installationItems: InstallationItem[]): PriceResult {
        if (!installationItems) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateOldSubtotalPrice(
                installationItems, CostDealType,
            ),
            priceB2C: this.calculateOldSubtotalPrice(
                installationItems, B2CDealType,
            ),
            priceB2B: this.calculateOldSubtotalPrice(
                installationItems, B2BDealType,
            ),
        };
    }

    private calculateOldSubtotalPrice(
        installationItems: InstallationItem[],
        dealType: string,
    ) {
        const oldSubtotalPrice = installationItems.reduce((sum, item) => sum + (item.sum.getSystemPrice(dealType).getValue() || 0), 0);

        return oldSubtotalPrice
    }
}
